import { useEffect, React} from 'react'
import Layout from '../../layouts/page'

const Index = () => {

  useEffect(() => {
    document.title = "Tuwe | Support"
  }, []);
  return (
    <Layout>
    <div class="col-lg-12 grid-margin stretch-card">
  <div class="card">
    <div class="card-body">
      <h3>Support</h3>
      
    </div>
  </div>
</div>
</Layout>
  )
}

export default Index